import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

const CurrencyConverter = () => {
    const [rates, setRates] = useState({});
    const [fromCurrency, setFromCurrency] = useState("USD");
    const [toCurrency, setToCurrency] = useState("BDT");
    const [amount, setAmount] = useState(1);
    const [convertedAmount, setConvertedAmount] = useState(0);
    const [loading, setLoading] = useState(false);

    const currencies = [
        "USD",
        "BDT",
        "EUR",
        "GBP",
        "INR",
        "AED",
        "SAR",
        "JPY",
        "CAD",
        "AUD"
    ];

    useEffect(() => {
        fetchRates();
    }, []);

    useEffect(() => {
        convertCurrency();
    }, [amount, fromCurrency, toCurrency, rates]);

    const fetchRates = async () => {

        try {

            setLoading(true);

            const response = await axios.get(
                `https://api.exchangerate-api.com/v4/latest/${fromCurrency}`
            );

            setRates(response.data.rates);

        } catch (error) {

            console.log(error);

        } finally {

            setLoading(false);

        }
    };

    useEffect(() => {
        fetchRates();
    }, [fromCurrency]);

    const convertCurrency = () => {

        if (rates[toCurrency]) {

            const result = amount * rates[toCurrency];
            setConvertedAmount(result.toFixed(2));

        }
    };

    return (
        <div className="text-white">

            <div className="flex items-center gap-2 mb-6">
                <div className="w-3 h-3 rounded-full bg-green-400 animate-pulse"></div>
                <h2 className="text-2xl font-bold">
                     {useTranslation().t("converter_title")}
                </h2>
            </div>

            <div className="space-y-5">

                {/* Amount */}
                <div>
                    <label className="text-sm text-gray-200 mb-2 block">
                        {useTranslation().t("amount_label")} 
                    </label>

                    <input
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 outline-none focus:border-white/40"
                    />
                </div>

                {/* From Currency */}
                <div>
                    <label className="text-sm text-gray-200 mb-2 block">
                        {useTranslation().t("form_label")} 
                    </label>

                    <select
                        value={fromCurrency}
                        onChange={(e) => setFromCurrency(e.target.value)}
                        className="w-full bg-black/20 border border-white/20 rounded-xl px-4 py-3 outline-none"
                    >
                        {
                            currencies.map((currency) => (
                                <option
                                    key={currency}
                                    value={currency}
                                    className="text-black"
                                >
                                    {currency}
                                </option>
                            ))
                        }
                    </select>
                </div>

                {/* To Currency */}
                <div>
                    <label className="text-sm text-gray-200 mb-2 block">
                        {useTranslation().t("to_label")}
                    </label>

                    <select
                        value={toCurrency}
                        onChange={(e) => setToCurrency(e.target.value)}
                        className="w-full bg-black/20 border border-white/20 rounded-xl px-4 py-3 outline-none"
                    >
                        {
                            currencies.map((currency) => (
                                <option
                                    key={currency}
                                    value={currency}
                                    className="text-black"
                                >
                                    {currency}
                                </option>
                            ))
                        }
                    </select>
                </div>

                {/* Result */}
                <div className="bg-white/10 rounded-2xl p-4 border border-white/20">
                    {
                        loading ? (
                            <p className="text-center">
                                Loading...
                            </p>
                        ) : (
                            <>
                                <p className="text-sm text-gray-300 mb-1">
                                   Converted Amount
                                </p>

                                <h3 className="text-3xl font-bold">
                                    {convertedAmount} {toCurrency}
                                </h3>
                            </>
                        )
                    }
                </div>

            </div>
        </div>
    );
};

export default CurrencyConverter;